/* global $ */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

function Exchange() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);

    const handleAddExchangeClick = () => {
        navigate('/addexchange');
    };

    useEffect(() => {
        const fetchRegistrationData = async () => {
            try {
                const response = await axiosInstance.get('/dealer/listforexchange');
            } catch (error) {
                console.error('Error fetching registration data:', error);
            }
        };

        fetchRegistrationData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get('/exchange/');

            setData(response.data.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    function formatDate(dateStr) {
        if (!dateStr) return ''; // Return empty string if dateStr is undefined or empty

        const date = new Date(dateStr); // Convert date string to Date object

        return date.toLocaleDateString('en-GB', {
            day: 'numeric',    // 10
            month: 'numeric',    // Mar
            year: 'numeric'    // 2024
        });
    }


    const handleEdit = async (row) => {
        //console.log("RowDetais:", row)
        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
        });

        if (result.isConfirmed) {
            navigate('/addexchange', { state: { row } });
        }
    };

    const handleAddStock = async (row) => {
        console.log("stockrow:", row)
        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Add this to Stock?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Add it!',
        });

        if (result.isConfirmed) {
            const created_by = localStorage.getItem('user_id')
            const newRecordData = {
                date: row.date,
                reg_no: row.exchange_reg_no,
                make_year: row.exchange_bike_make,
                model: row.exchange_bike_model,
                color: row.exchange_bike_color,
                chase_no: row.exchange_bike_chase_no,
                engine_no: row.exchange_bike_engine_no,
                noofowners: row.exchange_noofowners,
                buy_price: row.amount,
                dealer_name: row.name,
                dealer_address1: row.address1,
                dealer_address2: row.address2,
                dealer_address3: row.address3,
                dealer_city: row.city,
                dealer_phone1: row.phone1,
                dealer_phone2: row.phone2,
                created_by: created_by,
            };

            try {
                const response = await axiosInstance.post('/dealer/add', newRecordData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                //dealerId = response.data.dealer_id;
                if (response.data) {
                    const modified_by = localStorage.getItem('user_id')

                    const updatedData = {
                        isstocked: true,
                        modified_by: modified_by,
                    };

                    try {
                        await axiosInstance.put(`/exchange/${row.id}`, updatedData, {
                            headers: {
                                'Content-Type': 'application/json',
                            }

                        });

                        //Swal.fire('Updated!', 'The Exchange record has been updated.', 'success');
                    } catch (error) {
                        console.error('Error updating data:', error);
                        Swal.fire('Error!', 'There was an issue in updating the exchange record.', 'error');
                    }
                }

                await Swal.fire('Created!', 'The Dealer record has been Created.', 'success');
                fetchData();
            } catch (error) {
                console.error('Error creating new record:', error);
                // Extract error message from API response
                let errorMessage = 'There was an issue in saving the record.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message; // Get error message from backend response
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: errorMessage,
                });
            }
            navigate('/exchange', { state: { row } });
        }
    };


    const handleView = (row) => {
        setSelectedRow(row);
        $('#viewExchangeModal').modal('show');
    };

    const handleDelete = useCallback(async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
        if (result.isConfirmed) {
            // Optimistic UI update: Set 'inactive' to 0 immediately
            const updatedData = data.filter(item => item.id !== id);
            setData(updatedData); // Update the state immediately

            try {
                // Make a PUT request to update the 'inactive' field to 0
                await axiosInstance.delete(`/exchange/${id}`);

                Swal.fire('Deleted!', 'The exchange record has been deleted successfully.', 'success');
            } catch (error) {
                console.error('Error updating data:', error);
                Swal.fire('Error!', 'There was an issue in deleting exchange record.', 'error');

                // Revert the state if the request fails
                setData(prevData => [...prevData, data.find(item => item.id === id)]);
            }
        }
    }, [data]);


    const filteredData = data.filter(item =>
        (String(item.exchange_reg_no || '').toLowerCase().includes(searchText.toLowerCase())) ||
        (item.exchange_bike_model || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (item.exchange_bike_make || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (item.exchange_bike_color || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (String(item.amount || '').toLowerCase().includes(searchText.toLowerCase()))
    );

    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Date</span>,
            selector: row => formatDate(row.date),
            sortable: true,
            width: '130px',
            style: { fontWeight: '800' }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Registration No</span>,
            selector: row => row.exchange_reg_no,
            sortable: true,
            width: '180PX',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Model</span>,
            selector: row => row.exchange_bike_model,
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Make</span>,
            selector: row => row.exchange_bike_make,
            sortable: true,
            width: '200px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Color</span>,
            selector: row => row.exchange_bike_color,
            sortable: true,
            width: '200px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Amount</span>,
            selector: row => row.amount,
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Name</span>,
            selector: row => row.name,
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Status</span>,
            cell: row => (
                row.isstocked
                    ? <small className="badge badge-success"><i className="fa fa-check-circle"></i> Stocked</small>
                    : <small className="badge badge-warning">Pending</small>
            ),
            width: '100px'
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handleView(row)} className="btn btn-warning btn-sm" style={{ marginRight: '4px' }} title="View Details"><i className="fa fa-eye"></i></button>
                    {/* Show plus-circle only when isstocked is falsey */}
                    {(!row.isstocked || row.isstocked === 0) && (
                        <button
                            onClick={() => handleAddStock(row)}
                            className="btn btn-success btn-sm"
                            style={{ marginRight: '4px' }}
                            title="Add to stock"
                        >
                            <i className="fa fa-plus-circle"></i>
                        </button>
                    )}
                    <button onClick={() => handleEdit(row)} className="btn btn-primary btn-sm" style={{ marginRight: '4px' }} title="Edit"><i className="fa fa-edit"></i></button>
                    <button onClick={() => handleDelete(row.id)} className="btn btn-danger btn-sm"><i className="fa fa-times" title="Delete"></i></button>
                </div>
            ),
            width: '180px'
        }
    ];

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Exchange</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Exchange</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col d-flex justify-content-end">
                    <button
                        className="btn btn-primary mr-2"
                        onClick={handleAddExchangeClick}
                    >
                        <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
                        Add Exchange
                    </button>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                className="form-control mb-3"
                            />
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                paginationPerPage={100}
                                paginationRowsPerPageOptions={[100, 200, 300, 400]}
                            />
                        </div>
                    </div>
                </div >
            </div >

            {/* View Exchange Details Modal */}
            <div className="modal fade" id="viewExchangeModal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div className="modal-content">
                        <div className="modal-header bg-warning">
                            <h5 className="modal-title"><i className="fas fa-exchange-alt mr-2"></i>Exchange Details</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {selectedRow && (
                                <div className="container-fluid">
                                    <div className="row mb-2">
                                        <div className="col-sm-6">
                                            <p><strong>Date:</strong> {formatDate(selectedRow.date)}</p>
                                        </div>
                                        <div className="col-sm-6 text-right">
                                            {selectedRow.isstocked
                                                ? <span className="badge badge-success">Stocked</span>
                                                : <span className="badge badge-warning">Not Stocked</span>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <h6 className="text-primary"><i className="fas fa-motorcycle mr-1"></i>Exchange Vehicle</h6>
                                            <p><strong>Reg No:</strong> {selectedRow.exchange_reg_no}</p>
                                            <p><strong>Model:</strong> {selectedRow.exchange_bike_model}</p>
                                            <p><strong>Make Year:</strong> {selectedRow.exchange_bike_make}</p>
                                            <p><strong>Color:</strong> {selectedRow.exchange_bike_color}</p>
                                            <p><strong>Chassis No:</strong> {selectedRow.exchange_bike_chase_no}</p>
                                            <p><strong>Engine No:</strong> {selectedRow.exchange_bike_engine_no}</p>
                                            <p><strong>No of Owners:</strong> {selectedRow.exchange_noofowners}</p>
                                            <p><strong>Amount:</strong> ₹{selectedRow.amount}</p>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <h6 className="text-primary"><i className="fas fa-user-tie mr-1"></i>Owner Details</h6>
                                            <p><strong>Name:</strong> {selectedRow.name}</p>
                                            <p><strong>Address 1:</strong> {selectedRow.address1}</p>
                                            <p><strong>Address 2:</strong> {selectedRow.address2}</p>
                                            <p><strong>Address 3:</strong> {selectedRow.address3}</p>
                                            <p><strong>City:</strong> {selectedRow.city}</p>
                                            <p><strong>Phone 1:</strong> {selectedRow.phone1}</p>
                                            <p><strong>Phone 2:</strong> {selectedRow.phone2}</p>
                                        </div>
                                    </div>
                                    {selectedRow.note && (
                                        <div className="alert alert-light border">
                                            <strong>Note:</strong> {selectedRow.note}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </div >
    )
}

export default Exchange